module.exports = __webpack_public_path__ + "static/media/P1010284 - Version 2.a3e47cec.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/P1010284 - Version 2.JPG
// module id = 539
// module chunks = 0